import { PROD_MODE } from '@reverbdotcom/env';
import DOMPurify from 'dompurify';
import { info, gauge, currentSession } from './elog';

interface Data {
  referer: string;
  url: string;
  page_view_id: string;
  href: string;
}

// This hook's logic mimics that of the Ruby gem we use in core's SanitizationHelper class:
// https://github.com/rgrove/sanitize/blob/v6.0.0/lib/sanitize/transformers/clean_element.rb#L140-L144
if (DOMPurify.isSupported) {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    const HREF = 'href';
    const PROTOCOL_ALLOWLIST = ['http', 'https'];
    const PROTOCOL_REGEX = /A\s*([^/#]*?)(?::|&#0*58|&#x0*3a)/i;
    const UNSAFE_HREF_LOG_TAG = 'unsafe_href';

    if (node.hasAttribute(HREF)) {
      const href = node.getAttribute(HREF);

      const match = href.match(PROTOCOL_REGEX);
      const disallowed = match && !PROTOCOL_ALLOWLIST.includes(match[0].toLowerCase());

      if (disallowed) {
        const data = buildData(href);

        info(UNSAFE_HREF_LOG_TAG, data);

        gauge({
          name: UNSAFE_HREF_LOG_TAG,
          value: 1,
        });
      }
    }
  });
}

const buildData = (href: string): Data => {
  const session = currentSession();
  const referer = session.referer();
  const url = session.url();
  const page_view_id = session.pageViewID();

  return {
    referer,
    url,
    page_view_id,
    href,
  };
};

export const Purify = {
  sanitize(raw: string, tags?: object): string {
    if (DOMPurify.isSupported === false) {
      if (PROD_MODE) {
        throw new Error('Sanitize does not work in non DOM environments-- do not run this in production');
      }

      return raw;
    }

    return DOMPurify.sanitize(raw, tags);
  },
};

export default Purify;
